const storage = {
    not_configured: 'O provedor de armazenamento não está configurado.',
    missing_parameter: 'Faltando o parâmetro {{parameter}} para o provedor de armazenamento.',
    upload_error: 'Falha ao enviar o arquivo para o provedor de armazenamento.',
};
export default Object.freeze(storage);
